import { render, staticRenderFns } from "./DialogEditBankAccount.vue?vue&type=template&id=679bc2e2"
import script from "./DialogEditBankAccount.vue?vue&type=script&lang=js"
export * from "./DialogEditBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports